import React, { useEffect, useState } from 'react';
import { Table, Button, Form, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { FaEdit, FaTrash, FaPlusCircle, FaEye, FaFileInvoice } from 'react-icons/fa';


function CareRecipients() {
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [pdfFile, setPdfFile] = useState(null);
    const [selectedDate, setSelectedDate] = useState("");
    const [formErrors, setFormErrors] = useState({});
    const [organisationalSites, setOrganisationalSites] = useState([]);
    const [customerCareTypes, setCustomerCareTypes] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortKey, setSortKey] = useState("Name");
    const [sortOrder, setSortOrder] = useState("asc");
    const [showEditModal, setShowEditModal] = useState(false);
    const [loaded, setLoaded] = useState(false)
    const [newCustomer, setNewCustomer] = useState({
        Name: '',
        Surname: '',
        IDNo: '',
        Status: '',
        CustomerCareTypeID: '',
        Discount: '',
        OrganisationalSiteID: ''
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('https://marzdev.yourcrm.co.za/api/care-recipients');
                if (!response.ok) {
                    console.error(`HTTP error! Status: ${response.status}`);
                    return;
                }
                const data = await response.json();
                const sortedData = data.sort((a, b) =>
                    a.Name.localeCompare(b.Name)
                );
                setCustomers(sortedData);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        const fetchCustomerCareTypes = async () => {
            try {
                const response = await fetch('https://marzdev.yourcrm.co.za/api/customerCareTypes');
                if (response.ok) {
                    const data = await response.json();
                    console.log(data, 'data')
                    setCustomerCareTypes(data);
                } else {
                    console.error('Failed to fetch customer care types');
                }
            } catch (error) {
                console.error('An error occurred while fetching customer care types:', error);
            }
        };
        const fetchOrganisationalSites = async () => {
            try {
                const response = await fetch('https://marzdev.yourcrm.co.za/api/organisationalSites');
                if (response.ok) {
                    const data = await response.json();
                    setOrganisationalSites(data);
                } else {
                    console.error('Failed to fetch organisational sites');
                }
            } catch (error) {
                console.error('An error occurred while fetching organisational sites:', error);
            }
        };
        fetchData();
        fetchCustomerCareTypes();
        fetchOrganisationalSites();
    }, []);

    const handleSiteChange = (e) => {
        const selectedID = e.target.value;
        setSelectedCustomer((prevState) => ({
            ...prevState,
            OrganisationalSiteID: selectedID
        }));
    };

    const handleCareTypeChange = (e) => {
        const selectedID = e.target.value;
        setSelectedCustomer((prevState) => ({
            ...prevState,
            CustomerCareTypeID: selectedID
        }));
    };

    const handleSort = (key) => {
        const order = sortKey === key && sortOrder === "asc" ? "desc" : "asc";

        if (sortKey === key && sortOrder === order) return;

        setSortKey(key);
        setSortOrder(order);

        setCustomers((prevCustomers) =>
            [...prevCustomers].sort((a, b) =>
                order === "asc" ? (a[key] > b[key] ? 1 : -1) : (a[key] < b[key] ? 1 : -1)
            )
        );
    };

    const filteredCustomers = customers.filter(customer =>
        customer.Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        customer.Surname.toLowerCase().includes(searchTerm.toLowerCase()) ||
        customer.IDNo.includes(searchTerm)
    );

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleNewCustomerChange = (e) => {
        const { name, value } = e.target;
        setNewCustomer(prevState => ({ ...prevState, [name]: value }));
    };
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const uploadFile = async (file, customerID) => {
        const formData = new FormData();
        formData.append("pdfFile", file);  // Change to "pdfFile"
        
        try {
            const response = await fetch(`https://marzdev.yourcrm.co.za/api/upload.php?customerID=${customerID}`, {
                method: "POST",
                body: formData
            });
    
            const result = await response.json();
            
        } catch (error) {
            console.error("Error uploading file:", error);
            alert("An unexpected error occurred.");
        }
    };
    
    const handleUpload = async (customerID) => {
        if (selectedFile) {
            uploadFile(selectedFile, customerID);
        } 
    };

    // const downloadFile = (customerID) => {
    //     const fileUrl = `https://marzdev.yourcrm.co.za/api/upload.php?customerID=${customerID}`;
    //     window.open(fileUrl, "_blank");
    // };
    const downloadFile = async (customerID) => {
        const fileUrl = `https://marzdev.yourcrm.co.za/api/upload.php?customerID=${customerID}`;
    
        try {
            const response = await fetch(fileUrl);
            const data = await response.json();
    
            if (data.error === "File not found") {
                alert("File not found.");
            } else {
                window.open(fileUrl, "_blank");
            }
        } catch (error) {
            console.error("Error downloading file:", error);
            alert("An error occurred while downloading the file.");
        }
    };
    
    const validateForm = () => {
        const errors = {};
        if (!newCustomer.Name) errors.Name = 'Name is required';
        if (!newCustomer.Surname) errors.Surname = 'Surname is required';
        if (!newCustomer.IDNo) errors.IDNo = 'ID Number is required';
        if (!newCustomer.CustomerCareTypeID) errors.CustomerCareTypeID = 'Customer Care Type is required';
        if (!newCustomer.OrganisationalSiteID) errors.OrganisationalSiteID = 'Organisational Site is required';
        if (newCustomer.Discount === '') errors.Discount = 'Default discount is required';
        return errors;
    };

    const handleEdit = (e) => {
        const customer = customers.find(cust => cust.CustomerID === e);
        setSelectedCustomer(customer);
        setShowEditModal(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSelectedCustomer(prev => ({ ...prev, [name]: value }));
    };

    const handleEditModalClose = () => {
        setShowEditModal(false);
        setSelectedCustomer(null);
    };

    const handleSaveEdit = async () => {
        if (!selectedCustomer) return;

        try {
            const response = await fetch(`https://marzdev.yourcrm.co.za/api/care-recipients/${selectedCustomer.CustomerID}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(selectedCustomer)
            });

            if (response.ok) {
                alert('Customer updated successfully');
                setCustomers(customers.map(cust => cust.CustomerID === selectedCustomer.CustomerID ? selectedCustomer : cust));
                setShowEditModal(false);
            } else {
                alert('Failed to update customer');
            }
        } catch (error) {
            console.error('Error updating customer:', error);
        }
    };

    const handleAddCustomer = async () => {
        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }
        const formattedCustomer = {
            Name: newCustomer.Name || '', // Default to empty string if not provided
            Surname: newCustomer.Surname || '', // Default to empty string if not provided
            IDNo: newCustomer.IDNo || '', // Default to empty string if not provided
            CustomerCareTypeID: parseInt(newCustomer.CustomerCareTypeID, 10),
            Status: newCustomer.Status || 'ACTIVE', // Default to empty string if not provided
            Discount: newCustomer.Discount ? parseFloat(newCustomer.Discount) : null, // Default to null if not provided
            OrganisationalSiteID: newCustomer.OrganisationalSiteID ? parseInt(newCustomer.OrganisationalSiteID, 10) : null // Default to null if not provided
        };

        try {
            const response = await fetch('https://marzdev.yourcrm.co.za/api/care-recipients', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formattedCustomer)
            });

            if (response.ok) {
                const newCust = await response.json();
                setCustomers([...customers, newCust]);
                setShowModal(false);
                setNewCustomer({ Name: '', Surname: '', IDNo: '', Status: '', CustomerCareTypeID: '', Discount: '', OrganisationalSiteID: '' });
                handleUpload(newCustomer.IDNo);
                alert('Customer added successfully');
                window.location.reload(); // Reload the page after the alert
            } else {
                const errorMessage = await response.text();
                console.error('Failed to add customer:', errorMessage);
                alert('Failed to add customer');
            }
        } catch (error) {
            console.error('An unexpected error occurred:', error);
            alert('An unexpected error occurred');
        }
    };

    return (
        <div className=" mt-4">
            <h3>Care Recipients</h3>
            <Button variant="success" onClick={() => setShowModal(true)} className="mb-3">Add New Care Recipient</Button>
            <Form.Control
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="mb-3"
            />
            <div className='table-wrapper'>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Actions</th>
                            <th onClick={() => handleSort("Name")}>Name</th>
                            <th onClick={() => handleSort("Surname")}>Surname</th>
                            <th>Care Plans</th>
                            <th>Quotations</th>
                            <th onClick={() => handleSort("IDNo")}>ID Number</th>
                            <th onClick={() => handleSort("Status")}>Status</th>
                            <th>Care Recipient Care Type</th>
                            <th>Organisational Site</th>
                            <th>Default Discount Percentage</th>

                        </tr>
                    </thead>
                    <tbody>
                        {filteredCustomers.map((customer) => (
                            <tr key={customer.CustomerID}>
                                <td>
                                    <Button variant="link" data-tooltip-id={`edit-tooltip-${customer.CustomerID}`}>
                                        <FaEdit
                                            style={{ color: '#007bff', fontSize: '1.2rem' }}
                                            onClick={() => handleEdit(customer.CustomerID)}
                                        />
                                    </Button>
                                    <ReactTooltip style={{ zIndex: 1000 }} id={`edit-tooltip-${customer.CustomerID}`} place="top" content="Edit Activity" />
                                </td>
                                <td>{customer.Name}</td>
                                <td>{customer.Surname}</td>
                                <td>
                                    <Button variant="link" data-tooltip-id={`add-care-tooltip-${customer.CustomerID}`} as={Link} to={`/careplans/${customer.CustomerID}/${new Date().toISOString().slice(0, 10)}`}>
                                        <FaPlusCircle style={{ color: '#007bff', fontSize: '1.2rem' }} />
                                    </Button>
                                    <ReactTooltip id={`add-care-tooltip-${customer.CustomerID}`} style={{ zIndex: 1000 }} place="top" content="Add Care Plan" />

                                    <Button variant="link" data-tooltip-id={`view-care-tooltip-${customer.CustomerID}`} as={Link} to={`/careplans/${customer.CustomerID}`}>
                                        <FaEye style={{ color: '#28a745', fontSize: '1.2rem' }} />
                                    </Button>
                                    <ReactTooltip id={`view-care-tooltip-${customer.CustomerID}`} style={{ zIndex: 1000 }} place="top" content="View Care Plans" />
                                </td>

                                <td>
                                    <Button variant="link" data-tooltip-id={`view-quote-tooltip-${customer.CustomerID}`} as={Link} to={`/quotations/${customer.CustomerID}`}>
                                        <FaFileInvoice style={{ color: '#6c757d', fontSize: '1.2rem' }} />
                                    </Button>
                                    <ReactTooltip id={`view-quote-tooltip-${customer.CustomerID}`} place="top" style={{ zIndex: 1000 }} content="View Quotations" />
                                </td>
                                <td>{customer.IDNo}</td>
                                <td>{customer.Status}</td>
                                <td>{customer.CustomerCareTypeID}</td>
                                <td>
                                    {organisationalSites.find((item) => item.OrganisationalSiteID == customer.OrganisationalSiteID)?.OrganisationalSiteName || 'N/A'}
                                </td>
                                <td>{customer.Discount}</td>


                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            <Modal show={showModal} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add New Customer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="newCustomerName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="Name"
                                value={newCustomer.Name}
                                onChange={handleNewCustomerChange}
                                isInvalid={!!formErrors.Name}
                            />
                            <Form.Control.Feedback type="invalid">
                                {formErrors.Name}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group controlId="newCustomerSurname">
                            <Form.Label>Surname</Form.Label>
                            <Form.Control
                                type="text"
                                name="Surname"
                                value={newCustomer.Surname}
                                onChange={handleNewCustomerChange}
                                isInvalid={!!formErrors.Surname}
                            />
                            <Form.Control.Feedback type="invalid">
                                {formErrors.Surname}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group controlId="newCustomerIDNo">
                            <Form.Label>ID Number</Form.Label>
                            <Form.Control
                                type="text"
                                name="IDNo"
                                value={newCustomer.IDNo}
                                onChange={handleNewCustomerChange}
                                isInvalid={!!formErrors.IDNo}
                            />
                            <Form.Control.Feedback type="invalid">
                                {formErrors.IDNo}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group controlId="newCustomerCustomerCareTypeID">
                            <Form.Label>Customer Care Type</Form.Label>
                            <Form.Control
                                as="select"
                                name="CustomerCareTypeID"
                                value={newCustomer.CustomerCareTypeID}
                                onChange={handleNewCustomerChange}
                                isInvalid={!!formErrors.CustomerCareTypeID}
                            >
                                <option value="">Select a Care Type</option>
                                {customerCareTypes.map((careType) => (
                                    <option key={careType.CareTypeID} value={careType.CareTypeID}>
                                        {careType.Name}
                                    </option>
                                ))}
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">
                                {formErrors.CustomerCareTypeID}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group controlId="newCustomerOrganisationalSiteID">
                            <Form.Label>Organisational Site</Form.Label>
                            <Form.Control
                                as="select"
                                name="OrganisationalSiteID"
                                value={newCustomer.OrganisationalSiteID}
                                onChange={handleNewCustomerChange}
                                isInvalid={!!formErrors.OrganisationalSiteID}
                            >
                                <option value="">Select an Organisational Site</option>
                                {organisationalSites.map((site) => (
                                    <option key={site.OrganisationalSiteID} value={site.OrganisationalSiteID}>
                                        {site.OrganisationalSiteName}
                                    </option>
                                ))}
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">
                                {formErrors.OrganisationalSiteID}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group controlId="newCustomerDefaultDiscount">
                            <Form.Label>Default Discount Percentage</Form.Label>
                            <Form.Control
                                type="number"
                                name="Discount"
                                value={newCustomer.Discount}
                                onChange={handleNewCustomerChange}
                                isInvalid={!!formErrors.Discount}
                            />
                            <Form.Control.Feedback type="invalid">
                                {formErrors.Discount}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form>
                    <label htmlFor="formFile" className="form-label">Select a File</label>
                    <input type="file" id="formFile" className="form-control" onChange={handleFileChange} />

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalClose}>Close</Button>
                    <Button variant="primary"
                        onClick={() => {
    
                            handleAddCustomer();  
                        }}
                        >Add Customer</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showEditModal} onHide={handleEditModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Customer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="editCustomerName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={selectedCustomer?.Name}
                                onChange={(e) => setSelectedCustomer({ ...selectedCustomer, Name: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="editCustomerSurname">
                            <Form.Label>Surname</Form.Label>
                            <Form.Control
                                type="text"
                                value={selectedCustomer?.Surname}
                                onChange={(e) => setSelectedCustomer({ ...selectedCustomer, Surname: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="editCustomerIDNo">
                            <Form.Label>ID Number</Form.Label>
                            <Form.Control
                                type="text"
                                value={selectedCustomer?.IDNo}
                                onChange={(e) => setSelectedCustomer({ ...selectedCustomer, IDNo: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="editCustomerStatus">
                            <Form.Label>Status</Form.Label>
                            <Form.Control
                                as="select"
                                value={selectedCustomer?.Status}
                                onChange={(e) => setSelectedCustomer({ ...selectedCustomer, Status: e.target.value })}
                            >
                                <option value="ACTIVE">ACTIVE</option>
                                <option value="INACTIVE">INACTIVE</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="CustomerCareTypeID">
                            <Form.Label>Care Type</Form.Label>
                            <Form.Control
                                as="select"
                                name="CustomerCareTypeID"
                                value={selectedCustomer?.CustomerCareTypeID}
                                onChange={handleCareTypeChange}
                            >
                                <option value="">Select a Care Type</option>
                                {customerCareTypes.map((careType) => (
                                    <option key={careType.CareTypeID} value={careType.CareTypeID}>
                                        {careType.Name}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="OrganisationalSiteID">
                            <Form.Label>Organisational Site</Form.Label>
                            <Form.Control
                                as="select"
                                name="OrganisationalSiteID"
                                value={selectedCustomer?.OrganisationalSiteID}
                                onChange={handleSiteChange}
                            >
                                <option value="">Select an Organisational Site</option>
                                {organisationalSites.map((site) => (
                                    <option key={site.OrganisationalSiteID} value={site.OrganisationalSiteID}>
                                        {site.OrganisationalSiteName}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="editCustomerDiscount">
                            <Form.Label>Default Discount Percentage</Form.Label>
                            <Form.Control
                                type="number"
                                value={selectedCustomer?.Discount || ''}
                                onChange={(e) => setSelectedCustomer({ ...selectedCustomer, Discount: e.target.value })}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleEditModalClose}>Close</Button>
                    <Button variant="primary" onClick={() => downloadFile(selectedCustomer?.IDNo || '')}>
                        Download Current Assessment
                    </Button>
                    <Button variant="primary" onClick={handleSaveEdit}>Save Changes</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default CareRecipients;
